import RichEditor from './components/RichEditor';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'richEditor',
  pluginComponent: RichEditor,
});
